export default "__VITE_ASSET__CinC4y00__"